import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class CustomLocalTestUserInterceptor implements HttpInterceptor {
    public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        let headers = req.headers;

        const userId = window.localStorage.getItem('userId');

        if (userId) {
            headers = headers.append('Authorization', 'Mock ' + userId);
        }

        req = req.clone({
            headers,
        });

        return next.handle(req);
    }
}
